import React from 'react'
import { Container, Typography, Box, Grid, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import HeroSection from '../Components/HeroSection';
import ModernCard from '../Components/ModernCard';
import ModernFooter from '../Components/ModernFooter';
import Contact from '../Components/Contact';

import Services from "../Data/Services.json";
import Realisations from "../Data/Realisation.json";

import {
  Construction,
  Engineering,
  Architecture,
} from '@mui/icons-material';

import {
  fadeInUp,
  staggerChildren,
  staggerItem,
} from '../styles/animations';

import un_1 from "../Files/2sff_pv3x_211129.jpg";
import deux_2 from "../Files/18778.jpg";
import trois_3 from "../Files/night-modern-bridge.jpg";

function Home() {
    const { t, i18n } = useTranslation();
    const theme = useTheme();

    const serviceIcons = [
        <Construction />,
        <Engineering />,
        <Architecture />,
    ];

    // const projectIcons = [
    //     <Business />,
    //     <HomeWork />,
    //     <Apartment />,
    // ];

    return (
        <Box sx={{ backgroundColor: theme.palette.background.default }}>
            <HeroSection />
            
            {/* About Section */}
            <Box sx={{ py: 8, backgroundColor: theme.palette.background.default }}>
                <Container maxWidth="lg">
                    <motion.div
                        variants={fadeInUp}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Typography
                            variant="h3"
                            component="h2"
                            align="center"
                            gutterBottom
                            sx={{ fontWeight: 700, mb: 2, color: 'primary.main' }}
                        >
                            {t("contenu.texte1").toUpperCase()}
                        </Typography>
                        <Typography
                            variant="h5"
                            align="center"
                            color="text.secondary"
                            sx={{ mb: 4, maxWidth: 800, mx: 'auto' }}
                        >
                            {t("contenu.texte2")}
                        </Typography>
                        <Typography
                            variant="body1"
                            align="center"
                            sx={{ mb: 4, maxWidth: 1000, mx: 'auto', lineHeight: 1.7 }}
                        >
                            {t("contenu.texte3")}
                        </Typography>
                    </motion.div>
                </Container>
            </Box>

            {/* Services Section */}
            <Box sx={{ py: 8, backgroundColor: 'primary.main', color: 'white' }}>
                <Container maxWidth="lg">
                    <motion.div
                        variants={fadeInUp}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Typography
                            variant="h3"
                            component="h2"
                            align="center"
                            gutterBottom
                            sx={{ fontWeight: 700, mb: 2 }}
                        >
                            {t("contenu.texte23")}
                        </Typography>
                        <Typography
                            variant="h6"
                            align="center"
                            sx={{ mb: 6, opacity: 0.9 }}
                        >
                            {t("contenu.texte4")}
                        </Typography>
                    </motion.div>
                    
                    <motion.div
                        variants={staggerChildren}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Grid container spacing={4}>
                            {Services.map((service, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <motion.div variants={staggerItem}>
                                        <ModernCard
                                            variant="service"
                                            image=""
                                            title={service.title.split("|")[i18n.language.toLowerCase() === "fr" ? 0 : 1]}
                                            description={service.provider.split("|")[i18n.language.toLowerCase() === "fr" ? 0 : 1]}
                                            icon={serviceIcons[index]}
                                            link="/services"
                                            linkText={t("contenu.texte77")}
                                        />
                                    </motion.div>
                                </Grid>
                            ))}
                        </Grid>
                    </motion.div>
                </Container>
            </Box>

            {/* Stats Section */}
            <Box sx={{ py: 8, backgroundColor: theme.palette.background.default }}>
                <Container maxWidth="lg">
                    <motion.div
                        variants={fadeInUp}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Grid container spacing={4}>
                            <Grid item xs={6} md={3}>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="h3" fontWeight={700} color="primary.main">
                                        +15
                                    </Typography>
                                    <Typography variant="h6" color="text.secondary">
                                        {t("contenu.texte6")}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="h3" fontWeight={700} color="primary.main">
                                        +30
                                    </Typography>
                                    <Typography variant="h6" color="text.secondary">
                                        {t("contenu.texte7")}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="h3" fontWeight={700} color="primary.main">
                                        +11
                                    </Typography>
                                    <Typography variant="h6" color="text.secondary">
                                        {t("contenu.texte8")}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="h3" fontWeight={700} color="primary.main">
                                        +110
                                    </Typography>
                                    <Typography variant="h6" color="text.secondary">
                                        {t("contenu.texte9")}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </motion.div>
                </Container>
            </Box>

            {/* Projects Section */}
            <Box sx={{ py: 8, backgroundColor: theme.palette.background.paper }}>
                <Container maxWidth="lg">
                    <motion.div
                        variants={fadeInUp}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Typography
                            variant="h3"
                            component="h2"
                            align="center"
                            gutterBottom
                            sx={{ fontWeight: 700, mb: 2 }}
                        >
                            {t("contenu.texte10")}
                        </Typography>
                        <Typography
                            variant="h6"
                            align="center"
                            color="text.secondary"
                            sx={{ mb: 6 }}
                        >
                            {t("contenu.texte11")}
                        </Typography>
                    </motion.div>
                    
                    <motion.div
                        variants={staggerChildren}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Grid container spacing={4}>
                            {Realisations.slice(0, 3).map((project, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <motion.div variants={staggerItem}>
                                        <ModernCard
                                            variant="project"
                                            image={
                                                index === 0 ? un_1 :
                                                    index === 1 ? deux_2 :
                                                        trois_3
                                            }
                                            title={project.title.split("|")[i18n.language.toLowerCase() === "fr" ? 0 : 1]}
                                            description={project.provider.split("|")[i18n.language.toLowerCase() === "fr" ? 0 : 1]}
                                            link="/projects"
                                            linkText={t("voir-details")}
                                        />
                                    </motion.div>
                                </Grid>
                            ))}
                        </Grid>
                    </motion.div>
                </Container>
            </Box>

            {/* Contact Section */}
            <Box sx={{ py: 8, backgroundColor: 'primary.main', color: 'white' }}>
                <Container maxWidth="lg">
                    <Contact />
                </Container>
            </Box>
            
            <ModernFooter />
        </Box>
    )
}

export default Home